// 用于存放接口
export default {
  getBusinessList: '/iv.html?getBusinessList',
  updateDetail: '/iv.html?updateDetail', //  更新做题记录的接口
  getBgData: '/iv.html?getBgData', // 获取背景单据的接口
  getGoodsList: '/iv.html?getGoodsList', // 获取商品编码列表的接口
  saveGoods: '/iv.html?saveGoods', // 保存商品编码的接口
  deleteGoods: '/iv.html?deleteGoods', // 删除商品编码的接口
  getCustomList: '/iv.html?getCustomList', // 获取客户编码列表的接口
  saveCustom: '/iv.html?saveCustom', // 保存客户编码的接口
  deleteCustom: '/iv.html?deleteCustom', // 删除客户编码
  payInvoice: '/iv.html?payInvoice', // 购买发票
  getIcManageList: '/iv.html?getIcManageList', // 获取发票本列表
  importIcManage: '/iv.html?importIcManage', // 发票读入
  uploadGoodsCodeToOss: '/iv.html?uploadGoodsCodeToOss', // 上传税收分类编码的到Oss上
  getCodeList: '/iv.html?getCodeList', // 查询分类编码列表
  openInvoice: '/iv.html?openInvoice', // 打开填开发
  generateInvoice: '/iv.html?generateInvoice', // 发票填开
  getTaxClass: '/iv.html?getTaxClass', // 发票读入前的看看买了啥发票
  saveInvoice: '/iv.html?saveInvoice', // 保存发票的接口  负数发票保存
  updateInvoice: '/iv.html?updateInvoice', // 更新发票的状态
  getInvocieInfo: '/iv.html?getInvocieInfo', // 红字发票信息表填开获取发票信息
  getRedInvoice: '/iv.html?getRedInvoice', // 获取红字发票信息
  saveRedInvoice: '/iv.html?saveRedInvoice', // 保存红字发票
  getRedInvoiceList: '/iv.html?getRedInvoiceList', // 获取红字发票列表
  getInvoiceList: '/iv.html?getInvoiceList', // 发票的库存查询
  seeInvoiceDetail: '/iv.html?seeInvoiceDetail', // 查看明细
  updateRedInvoice: '/iv.html?updateRedInvoice', // 红字发票上传
  seeRedInvoiceDetail: '/iv.html?seeRedInvoiceDetail', // 红字发票查看明细
  getNegInvoiceInfo: '/iv.html?getNegInvoiceInfo', // 负数发票直接开具 - 获取发票信息
  getNegInvoice: '/iv.html?getNegInvoice', // 负数发票 - 直接开具 - 开具
  finishTest: '/iv.html?finishTest', // 业务完成后的判分
  examTest: '/iv.html?examTest', // 查看做题记录
  saveSsbm: '/iv.html?saveSsbm', // 保存税收编码
  checkTabPipeNum: '/iv.html?checkTabPipeNum', //  信息表编号确认
  getModuleList: '/invoice.html?getModuleList', // 获取答案列表
  getRightAnswer: '/invoice.html?getRightAnswer', // 获取正确答案列表
  getStuAnswer: '/invoice.html?getStuAnswer', // 获取学员答案列表
  getVideoParams: '/invoice.html?getVideoParams', // 获取视频参数
  invoiceStatistics: '/iv.html?invoiceStatistics', // 获取统计信息
  onLineApplyInvoice: '/iv.html?onLineApplyInvoice', // 网上发票申领
  applyList: '/iv.html?applyList', // 发票申领状态查询
  applyConfirmList: '/iv.html?applyConfirmList', // 发票申领确认 查询
  applyDismissList: '/iv.html?applyDismissList', // 发票申领撤销 查询
  drawInvoiceList: '/iv.html?drawInvoiceList', // 网上领票确认 查询
  applyConfirm: '/iv.html?applyConfirm', // 申领状态确认
  applyDismiss: '/iv.html?applyDismiss', // 申领状态撤销
  onLinePayInvoice: '/iv.html?onLinePayInvoice', // 发票下载
  searchInvoiceNum: '/iv.html?searchInvoiceNum', // 网上领票量查询
  getExpressAddrInfo: '/iv.html?getExpressAddrInfo', // 获取快递地址信息
  // getVideoPrefix: 'https://rspm.accfun.com/vo.html?video' // 视频播放接口
}
